import { Navigate, useLocation } from 'react-router';
import { BACK_TESTING_PATH, PLAYGROUND_PATH, SIMULATOR_PATH, TEST_PREFIX } from '@/constants/paths';
import { useVisibleSubItems } from '@/hooks/use-visible-sub-items';
import SecondarySidebarLayout from './secondary-sidebar-layout';

export default function TestLayout() {
	// Back testing puts the SOP, its scenario types and their scenarios side by side, and the
	// Playground its chats, the chat and how Kim answered; 200px of nav is the first thing
	// worth trading away for either.
	return (
		<SecondarySidebarLayout
			title='Test'
			items={useVisibleSubItems(TEST_PREFIX)}
			autoCollapsePaths={[BACK_TESTING_PATH, PLAYGROUND_PATH]}
		/>
	);
}

/** Lands /test on the first section the user can see, keeping the query. */
export function TestIndexRedirect() {
	const items = useVisibleSubItems(TEST_PREFIX);
	const { search } = useLocation();
	return <Navigate to={(items[0]?.path ?? SIMULATOR_PATH) + search} replace />;
}
